

export default {
  name: "the-identifier",
  props: {
      title: {
        required: true,
        default: ''
      },
      description: {
        required: true,
        default: ''
      },
      error: {
        required: false,
        default: '',
        type: String
      },
      layout: {
        required: false,
        default: 'chain',
        type: String
      }
    },
  components: {
    
  },
  data() {
    return {
     identifier: '',
    };
  },
  methods: {
    submit(event){
      event.preventDefault();
      this.onInput(event?.srcElement?._value)
      this.$emit("verify");
    },
    onInput(value) {
        this.$emit("setValue", value);
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.identifierInput.$refs.input.focus()
      })
    })
  }
};
